/*
- Query Strings übernehmen ins Formular

Personenauswahl

	Select: Anzahl Wohneinheiten 1-3

	AuswahlTyp:
	- Beliebige Art (default)
	- Zimmer
		Einzelzimmer (single)
		Doppelzimmer (double)
	- Ferienwohnung (flat)
		Falls ausgewählt: Zusätzliche Auswahl Anzahl Schlafzimmer [1-4]
	- Ferienhaus (house)
	- Stellplatz (campsite)
	- Betten (beds)

	SelectRow = [AuswahlTyp] [AnzahlSchlafzimmer:optional] [Erwachsense:1-15] [Kinder:1-5] [Kind1] [Kind2] [Kind3] [Kind4] [Kind5]

	A [SelectRow]
	B [SelectRow]
	C [SelectRow]

{
	rooms: int,
	rooms.1.type: single|double|flat|house|campsite|beds,
	rooms.1.schlafzimmer: int,
	rooms.1.adults: int,
	rooms.1.children: int,
	rooms.1.child1: int,
	rooms.1.child2: int,
	rooms.1.child3: int,
	rooms.1.child4: int,
	rooms.1.child5: int,
}

*/

var _ = require('underscore');
var Registry = require('registry');

/* General structure */

var returnTrue = function() { return true };

/**
 * Erzeugt die Formular-Struktur für das Personen-Auswahl-Feld
 *
 * @param model {Backbone.Model} Model welches die Formular-Daten enthält
 */
module.exports = function(model, use_filter) {
	if ( typeof use_filter === "undefined" ) {
		use_filter = true;
	}

	var structure = [];

	// Wenn wir 0 als Raum bekommen, müssen wir das auf 1 hochcasten.
	// Oh da das hier JS ist, kann es auch "0" sein, was true'ish ist.
	var rooms = parseInt(model.get("rooms"), 10) || 1;

	if ( Registry.get("PeopleStructure.ShowMultiRooms") || !use_filter ) {
		structure.push({
			key: "rooms",
			class: "rooms",
			values: [
				[0, "Ohne Wohneinheit"],
				[1, "1 Wohneinheit"],
				[2, "2 Wohneinheiten"],
				[3, "3 Wohneinheiten"],
			],
		});
	}

	var makeChildSelect = function(prefix, c, room_index) {
		return {
			key: prefix + "child" + c,
			values: [
				[0, __("age")],
				[1, "1 Jahr"],
				[2, "2 Jahre"],
				[3, "3 Jahre"],
				[4, "4 Jahre"],
				[5, "5 Jahre"],
				[6, "6 Jahre"],
				[7, "7 Jahre"],
				[8, "8 Jahre"],
				[9, "9 Jahre"],
				[10, "10 Jahre"],
				[11, "11 Jahre"],
				[12, "12 Jahre"],
				[13, "13 Jahre"],
				[14, "14 Jahre"],
				[15, "15 Jahre"],
				[16, "16 Jahre"],
				[17, "17 Jahre"],
			],
			condition: function(model) {
				if ( rooms < room_index ) return false;
				return model.get(prefix + "children") >= c;
			},
		};
	};


	/* Each location block */
	_.each(['A', 'B', 'C'], function(group, i) {
		var index = i + 1;
		var prefix = "rooms." + index + ".";

		structure.push({
			type: 'groupStart',
			group: group,
			condition: function(model) {
				return rooms >= index && rooms > 1;
			},
		});

		structure.push({
			key: prefix + "type",
			class: "room-type",
			valuesFunc: function(model) {
				let defaults = [
					["any", __("housing_any")],
					["room", __("housing_room")],
					["single", "&nbsp; " + __("housing_single")],
					["double", "&nbsp; " + __("housing_double")],
					["flat", __("housing_flat")],
					["house", __("housing_house")],
				];

				if ( Registry.get("Customer").Bergwelt ) {
					defaults = [
						["any", __("housing_any")],
						["flat", __("housing_flat")],
						["house", __("housing_house")],
					];
				}

				if ( 
					! Registry.get("Customer").Wertach 
					&& ! Registry.get("Customer").Bergwelt 
					&& ! Registry.get("Customer").Oberstdorf 
					&& ! Registry.get("Customer").Scheidegg 
				) {
					defaults.push(["campsite", __("housing_campsite")]);
				}

				return defaults;
			},
			condition: function(model) {
				if ( !Registry.get("PeopleStructure.ShowRoomTypes", true) ) return false;
				return rooms >= index;
			},
		});

		structure.push({
			key: prefix + "bedrooms",
			values: [
				[0, __("bedroom_count")],
				[1, "1 " + __("bedroom")],
				[2, "2 " + __("bedrooms")],
				[3, "3 " + __("bedrooms")],
			],
			condition: function(model) {
				if ( !Registry.get("PeopleStructure.ShowRoomTypes", true) ) return false;
				if ( rooms < index ) return false;
				return model.get(prefix + "type") == "flat";
			},
		});

		structure.push({
			key: prefix + "adults",
			class: "room-adults",
			valuesFunc: function(model) {
				var type = model.get(prefix + "type");
				var selectable = {
					"any": model.get("room_limit_any") || 18,
					"room": model.get("room_limit_room") || 9,
					"single": model.get("room_limit_single") || 2,
					"double": model.get("room_limit_double") || 3,
					"flat": model.get("room_limit_flat") || 15,
					"house": model.get("room_limit_house") || 18,
					"campsite": model.get("room_limit_campsite") || 9,
					"beds": model.get("room_limit_beds") || 18,
				}[type];

				var values = [
					[1, "1 " + __("adult")],
				];
				for( var i = 1; i < selectable; i++ ) {
					values.push([i + 1, i + 1 + " " + __("adults")]);
				}
				return values;
			},
			condition: function(model) {
				return rooms >= index;
			},
		});

		structure.push({
			key: prefix + "children",
			class: "room-childage",
			values: [
				[0, __("no_children")],
				[1, __("one_child")],
				[2, "2 " + __("children")],
				[3, "3 " + __("children")],
				[4, "4 " + __("children")],
				[5, "5 " + __("children")],
			],
			condition: function(model) {
				if ( model.get("no_children") ) return false;
				return rooms >= index;
			},
		});

		for(var c = 1; c <= 5; c++) {
			structure.push(makeChildSelect(prefix, c, i));
		}

		structure.push({
			type: 'groupEnd',
			group: group,
			condition: function(model) {
				return rooms >= index && rooms > 1;
			},
		});

	});

	/* Apply defaults to all items */
	_(structure).each(function(item) {
		if ( !item.type ) item.type = "select";
		if ( !item.class ) item.class = "";
		if ( !item.condition ) item.condition = returnTrue;

		if ( typeof item.valuesFunc === "function" ) {
			item.values = item.valuesFunc(model);
		}
	});


	if ( use_filter ) {
		structure = _.filter(structure, function(item) {
			return item.condition(model);
		});
	}
	return structure;
};



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/reserva/engine/views/PeopleStructure.js